import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const Stars = () => (
    <div style={{ position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0 }}>
        {Array.from({ length: 80 }, (_, i) => (
            <div key={i} style={{
                position: 'absolute',
                width: Math.random() * 3 + 1 + 'px',
                height: Math.random() * 3 + 1 + 'px',
                background: 'white',
                borderRadius: '50%',
                left: Math.random() * 100 + '%',
                top: Math.random() * 100 + '%',
                opacity: Math.random() * 0.7 + 0.1,
                animation: `twinkle ${Math.random() * 3 + 2}s ease-in-out infinite`,
                animationDelay: Math.random() * 3 + 's'
            }} />
        ))}
        <style>{`@keyframes twinkle{0%,100%{opacity:0.1}50%{opacity:0.8}}`}</style>
    </div>
);

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { login } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); setLoading(true);
        try {
            await login(email, password);
            toast.success('Connexion réussie !');
        } catch (err) {
            setError(err.response?.data?.message || 'Email ou mot de passe incorrect');
        }
        setLoading(false);
    };

    const inputStyle = {
        width: '100%', padding: '13px 16px',
        background: 'rgba(255,255,255,0.05)',
        border: '1px solid rgba(0,212,255,0.2)',
        borderRadius: 10, fontSize: 14,
        color: 'white', fontFamily: 'inherit', outline: 'none',
        transition: 'all 0.2s', boxSizing: 'border-box'
    };

    return (
        <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#0a1628 0%,#0f2744 50%,#0a1628 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, position: 'relative' }}>
            <Stars />
            <div style={{ position: 'relative', zIndex: 1, width: '100%', maxWidth: 420 }}>
                <div style={{ background: 'rgba(255,255,255,0.04)', backdropFilter: 'blur(20px)', border: '1px solid rgba(0,212,255,0.2)', borderRadius: 24, padding: '48px 44px', boxShadow: '0 25px 60px rgba(0,0,0,0.5)' }}>
                    <div style={{ textAlign: 'center', marginBottom: 36 }}>
                        <div style={{ width: 64, height: 64, background: 'linear-gradient(135deg,#1e6fe0,#00d4ff)', borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, fontWeight: 900, color: 'white', margin: '0 auto 16px', boxShadow: '0 0 30px rgba(0,212,255,0.4)' }}>CS</div>
                        <h1 style={{ fontSize: 24, fontWeight: 800, color: 'white', marginBottom: 6 }}>CS FORM</h1>
                        <p style={{ fontSize: 13, color: 'rgba(0,212,255,0.7)', letterSpacing: 1, textTransform: 'uppercase' }}>Espace Administrateur</p>
                    </div>

                    {error && (
                        <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 10, padding: '10px 14px', marginBottom: 20, fontSize: 13, color: '#fca5a5' }}>
                            ⚠️ {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        <div style={{ marginBottom: 18 }}>
                            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.6)', marginBottom: 7 }}>Email</label>
                            <input type="email" style={inputStyle} value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@csform.com" required autoFocus />
                        </div>
                        <div style={{ marginBottom: 28 }}>
                            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.6)', marginBottom: 7 }}>Mot de passe</label>
                            <input type="password" style={inputStyle} value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
                        </div>
                        <button type="submit" disabled={loading} style={{ width: '100%', background: 'linear-gradient(135deg,#1e6fe0,#00d4ff)', border: 'none', borderRadius: 12, padding: '14px', fontSize: 15, fontWeight: 700, color: 'white', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, boxShadow: '0 0 30px rgba(0,212,255,0.3)', fontFamily: 'inherit' }}>
                            {loading ? '⏳ Connexion...' : '🔑 Se connecter'}
                        </button>
                    </form>

                    <div style={{ textAlign: 'center', marginTop: 24, fontSize: 12, color: 'rgba(255,255,255,0.2)' }}>
                        CS FORM — Portail Administration
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;